import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface ModalProps {
  isOpen: boolean | string;
  onClose: () => void;
  children: ReactNode;
  width?:string;
}


const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children,  width = "671px" }) => {
  if (!isOpen) return null;

  return (
    <Overlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()} style={{  width: width}}>
        <Content>{children}</Content>
      </ModalContainer>
    </Overlay>
  );
};

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #292D32E5;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background: white;
  border-radius: 8px;
  position: relative;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  img{
    border-radius:15px;
  }

  /* Mobile: fit to viewport */
  @media (max-width: 768px) {
    width: calc(100vw - 32px) !important;
    max-width: calc(100vw - 32px) !important;
    max-height: calc(100dvh - 32px);
    overflow: auto;
    border-radius: 16px;
  }
`;

const Content = styled.div`

`;


export default Modal;
